import LeadForm from "@/components/public/LeadForm";
import { usePageMeta } from "@/lib/seo";
import { Mail, Phone, Clock, MessageSquare, LifeBuoy } from "lucide-react";

export default function ContactPage() {
  usePageMeta("contact");
  return (
    <div data-testid="contact-page">
      <div className="bg-slate-950 pt-36 pb-20 text-white">
        <div className="mx-auto max-w-4xl px-5 text-center lg:px-8">
          <p className="text-sm font-semibold uppercase tracking-widest text-blue-400">Contact</p>
          <h1 className="mt-3 font-display text-4xl font-extrabold tracking-tight sm:text-5xl">Talk to our team</h1>
          <p className="mx-auto mt-5 max-w-2xl text-lg text-slate-300">
            Questions about RideStamp? Send us a note and we'll get back to you.
          </p>
        </div>
      </div>

      <div className="mx-auto max-w-6xl px-5 py-20 lg:px-8 lg:py-24">
        <div className="grid gap-12 lg:grid-cols-[0.8fr_1.2fr]">
          <div className="space-y-6">
            {[
              [Mail, "Email", "hello@myridestamp.com"],
              [LifeBuoy, "Support", "support@myridestamp.com"],
              [Phone, "Phone", "(339) 234-4636"],
              [Clock, "Hours", "Mon–Fri, 8am–6pm CT"],
              [MessageSquare, "Sales", "Ask for a tailored walkthrough"],
            ].map(([Icon, t, d]) => (
              <div key={t} className="flex items-start gap-4">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-blue-50 text-blue-700"><Icon className="h-5 w-5" /></span>
                <div>
                  <h3 className="font-display text-base font-bold text-slate-900">{t}</h3>
                  <p className="mt-0.5 text-slate-600">{d}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="rounded-2xl border border-slate-200 bg-white p-7 shadow-sm lg:p-9">
            <h2 className="font-display text-xl font-bold text-slate-900">Send us a message</h2>
            <p className="mt-1 text-sm text-slate-500">We typically respond within one business day.</p>
            <div className="mt-6">
              <LeadForm type="contact" submitLabel="Send Message" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
